<app-table
  [lazy]="true"
  [cols]="columns"
  tableTitle="Comissões Duplicadas"
  [addButton]="false"
  [exportPdf]="false"
  [exportExcel]="false"
  [refreshButton]="false"
  [service]="itOpsService"
  pageFunctionName="getDoubleCommissionTable"
  emptyMessage="Sem mais comissões duplicadas no momento."
  selectionActionLabel="Corrigir"
  selectionActionTooltip="Marcar como resolvido"
  selectionActionIcon="pi pi-check"
  (emitSelection)="markAsResolved($event)"
  modelName="Registros"
  [defaultRows]="15"
  [dropdownFilters]="dropdownFilters"
  [multiSelectFilter]="true"
  *ngIf="dropdownFilters"
></app-table>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
